import { Grid } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import RxBox from "../../../components/RxBox";
import RxButton from "../../../components/RxButton";
import RxCheckBox from "../../../components/RxCheckBox";
import RxMaskedTextField from "../../../components/RxMaskedTextField";
import RxTextField from "../../../components/RxTextField";
import RxTypography from "../../../components/RxTypography";
import { RxPaymentObject } from "../PaymentObject";
import { PaymentStepFormValidationObject } from "../PaymentPage";
import styles from "./PaymentInfoStep.module.css";
import PaymentInfoStepValidation from "./PaymentInfoStepValidation";

interface PaymentInfoStepProps {
	setValidataResult?: any;
	values: RxPaymentObject;
}

const PaymentInfoStep = (props: PaymentInfoStepProps) => {
	const formik = useFormik({
		initialValues: props.values,
		validationSchema: PaymentInfoStepValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			// Form submit edilmediği için bulunuyor. (Sonar uyarısı için)
			console.log("No submit button for this form...");
		},
	});

	useEffect(() => {
		if (!formik.isValid) {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: PaymentStepFormValidationObject
					): PaymentStepFormValidationObject => {
						return {
							...prev,
							isInfoStepValid: false,
						};
					}
				);
		} else {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: PaymentStepFormValidationObject
					): PaymentStepFormValidationObject => {
						return {
							...prev,
							isInfoStepValid: true,
						};
					}
				);
		}
	}, [formik.isValid]); // eslint-disable-line

	useEffect(() => {
		props.setValidataResult &&
			props.setValidataResult(
				(
					prev: PaymentStepFormValidationObject
				): PaymentStepFormValidationObject => {
					return {
						...prev,
						values: {
							...formik.values,
						},
					};
				}
			);
	}, [formik.values]); // eslint-disable-line

	useEffect(() => {
		formik.validateForm();
	}, []); // eslint-disable-line

	const transferInvoiceInfoToDeliveryInfo = async () => {
		formik.values.invoiceInfo.isCompany &&
			(await formik.setFieldValue(
				"deliveryInfo.company",
				formik.values.invoiceInfo.company
			));
		!formik.values.invoiceInfo.isCompany &&
			(await formik.setFieldValue(
				"deliveryInfo.nameSurname",
				formik.values.invoiceInfo.nameSurname
			));

		await formik.setFieldValue(
			"deliveryInfo.address",
			formik.values.invoiceInfo.address
		);
		await formik.setFieldValue(
			"deliveryInfo.district",
			formik.values.invoiceInfo.district
		);
		await formik.setFieldValue(
			"deliveryInfo.province",
			formik.values.invoiceInfo.province
		);
		await formik.setFieldValue(
			"deliveryInfo.country",
			formik.values.invoiceInfo.country
		);

		formik.validateForm();
	};

	return (
		<form>
			<Grid container direction="row" spacing={5}>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={1}>
						{/* Fatura Bilgileri */}
						<Grid item xs={12} sm={6}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant="body1"
										align="center"
										color="primary"
										label="Fatura Bilgileri"
										className={styles.titleBackground}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={4}>
									<RxCheckBox
										className={styles.customMargin}
										label="Kurum Faturası"
										checked={formik.values.invoiceInfo.isCompany}
										outOnChange={formik.handleChange}
										outId="invoiceInfo.isCompany"
										outName="invoiceInfo.isCompany"
									/>
								</Grid>
								<Grid item xs={12} sm={8}></Grid>
							</Grid>
							<Grid container spacing={1}>
								{formik.values.invoiceInfo.isCompany && (
									<Grid item xs={12} sm={12}>
										<RxTextField
											fullwidth
											id="invoiceInfo.company"
											name="invoiceInfo.company"
											label="Kurum / Firma"
											placeholder="Kurum / Firma"
											value={formik.values.invoiceInfo.company}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											required={formik.values.invoiceInfo.isCompany}
											error={Boolean(
												formik.errors.invoiceInfo?.company
											)}
										/>
									</Grid>
								)}
								{!formik.values.invoiceInfo.isCompany && (
									<Grid item xs={12} sm={6}>
										<RxTextField
											fullwidth
											id="invoiceInfo.nameSurname"
											name="invoiceInfo.nameSurname"
											label="Ad Soyad"
											placeholder="Ad Soyad"
											value={formik.values.invoiceInfo.nameSurname}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											required={!formik.values.invoiceInfo.isCompany}
											error={Boolean(
												formik.errors.invoiceInfo?.nameSurname
											)}
										/>
									</Grid>
								)}
								{!formik.values.invoiceInfo.isCompany && (
									<Grid item xs={12} sm={6}>
										<RxMaskedTextField
											fullwidth
											id="invoiceInfo.identityId"
											name="invoiceInfo.identityId"
											label="TC Kimlik No"
											placeholder="TC Kimlik No"
											mask="99999999999"
											value={formik.values.invoiceInfo.identityId}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											required
											error={Boolean(
												formik.errors.invoiceInfo?.identityId
											)}
										/>
									</Grid>
								)}
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTextField
										fullwidth
										id="invoiceInfo.address"
										name="invoiceInfo.address"
										label="Adres"
										placeholder="Adres"
										multiline
										maxRow={2}
										minRow={2}
										value={formik.values.invoiceInfo.address}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.invoiceInfo?.address
										)}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={4}>
									<RxTextField
										fullwidth
										id="invoiceInfo.district"
										name="invoiceInfo.district"
										label="İlçe"
										placeholder="İlçe"
										value={formik.values.invoiceInfo.district}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.invoiceInfo?.district
										)}
									/>
								</Grid>
								<Grid item xs={12} sm={4}>
									<RxTextField
										fullwidth
										id="invoiceInfo.province"
										name="invoiceInfo.province"
										label="Şehir"
										placeholder="Şehir"
										value={formik.values.invoiceInfo.province}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.invoiceInfo?.province
										)}
									/>
								</Grid>
								<Grid item xs={12} sm={4}>
									<RxTextField
										fullwidth
										id="invoiceInfo.country"
										name="invoiceInfo.country"
										label="Ülke"
										placeholder="Ülke"
										value={formik.values.invoiceInfo.country}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.invoiceInfo?.country
										)}
									/>
								</Grid>
							</Grid>
							{formik.values.invoiceInfo.isCompany && (
								<Grid container spacing={1}>
									<Grid item xs={12} sm={6}>
										<RxTextField
											fullwidth
											id="invoiceInfo.taxAdmin"
											name="invoiceInfo.taxAdmin"
											label="Vergi Dairesi"
											placeholder="Vergi Dairesi"
											value={formik.values.invoiceInfo.taxAdmin}
											onChange={formik.handleChange}
											required={formik.values.invoiceInfo.isCompany}
											error={Boolean(
												formik.errors.invoiceInfo?.taxAdmin
											)}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<RxTextField
											fullwidth
											id="invoiceInfo.taxNo"
											name="invoiceInfo.taxNo"
											label="Vergi No"
											placeholder="Vergi No"
											value={formik.values.invoiceInfo.taxNo}
											onChange={formik.handleChange}
											required={formik.values.invoiceInfo.isCompany}
											error={Boolean(
												formik.errors.invoiceInfo?.taxNo
											)}
										/>
									</Grid>
								</Grid>
							)}
						</Grid>
						{/* Teslimat Bilgileri */}
						<Grid item xs={12} sm={6}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant="body1"
										align="center"
										color="primary"
										label="Teslimat Bilgileri"
										className={styles.titleBackground}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6}>
									<RxTextField
										fullwidth
										id="deliveryInfo.nameSurname"
										name="deliveryInfo.nameSurname"
										label="İlgili Kişi"
										placeholder="İlgili Kişi"
										value={formik.values.deliveryInfo.nameSurname}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.deliveryInfo?.nameSurname
										)}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<RxMaskedTextField
										fullwidth
										id="deliveryInfo.phone"
										name="deliveryInfo.phone"
										mask="9(999)-999-99-99"
										label="Telefon"
										placeholder="Telefon"
										value={formik.values.deliveryInfo.phone}
										onChange={formik.handleChange}
										required
										error={Boolean(formik.errors.deliveryInfo?.phone)}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTextField
										fullwidth
										id="deliveryInfo.company"
										name="deliveryInfo.company"
										label="Kurum / Firma"
										placeholder="Kurum / Firma"
										value={formik.values.deliveryInfo.company}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.deliveryInfo?.company
										)}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTextField
										fullwidth
										id="deliveryInfo.address"
										name="deliveryInfo.address"
										label="Adres"
										placeholder="Adres"
										multiline
										maxRow={2}
										minRow={2}
										value={formik.values.deliveryInfo.address}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.deliveryInfo?.address
										)}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={4}>
									<RxTextField
										fullwidth
										id="deliveryInfo.district"
										name="deliveryInfo.district"
										label="İlçe"
										placeholder="İlçe"
										value={formik.values.deliveryInfo.district}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.deliveryInfo?.district
										)}
									/>
								</Grid>
								<Grid item xs={12} sm={4}>
									<RxTextField
										fullwidth
										id="deliveryInfo.province"
										name="deliveryInfo.province"
										label="Şehir"
										placeholder="Şehir"
										value={formik.values.deliveryInfo.province}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.deliveryInfo?.province
										)}
									/>
								</Grid>
								<Grid item xs={12} sm={4}>
									<RxTextField
										fullwidth
										id="deliveryInfo.country"
										name="deliveryInfo.country"
										label="Ülke"
										placeholder="Ülke"
										value={formik.values.deliveryInfo.country}
										onChange={formik.handleChange}
										required
										error={Boolean(
											formik.errors.deliveryInfo?.country
										)}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTextField
										fullwidth
										id="deliveryInfo.note"
										name="deliveryInfo.note"
										label="Not"
										placeholder="Not"
										multiline
										maxRow={4}
										minRow={4}
										value={formik.values.deliveryInfo.note}
										onChange={formik.handleChange}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxButton
										color="inherit"
										variant="contained"
										label="Fatura Bilgilerimi Teslimat Bilgisi Olarak Aktar"
										onClick={() => {
											transferInvoiceInfoToDeliveryInfo();
										}}
										className={styles.marginTopFifteen}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid container spacing={1}>
						{/* Hata Mesajı */}
						<Grid item xs={12} sm={12}>
							{!formik.isValid ? (
								<RxBox
									color="red"
									className={styles.warningBox}
									label="* Bulunan alanların doldurulması zorunludur."
								/>
							) : (
								<br />
							)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
};

export default PaymentInfoStep;
